import { GOOGLE_ANALYTICS_COOKIE_MAX_AGE } from "@/app/vars/Storage";

export class UConsent {
  private static readonly GTAG_URL = "https://www.googletagmanager.com/gtag/js";

  public static googleAnalyticsScriptUrl(gaId: string): string {
    return `${UConsent.GTAG_URL}?id=${encodeURIComponent(gaId)}`;
  }

  public static googleAnalyticsInitScript(gaId: string): string {
    return [
      "window.dataLayer = window.dataLayer || [];",
      "function gtag(){window.dataLayer.push(arguments);}",
      "gtag('js', new Date());",
      `gtag('config', ${JSON.stringify(gaId)}, { cookie_expires: ${GOOGLE_ANALYTICS_COOKIE_MAX_AGE} });`,
    ].join("\n");
  }

  public static setGoogleAnalyticsDisabled(gaId: string, disabled: boolean): void {
    if (typeof window === "undefined") {
      return;
    }

    Reflect.set(window, `ga-disable-${gaId}`, disabled);
  }
}
